import { render, staticRenderFns } from "./tensionBeatsColumnChart.vue?vue&type=template&id=c15cdd6a&scoped=true"
import script from "./tensionBeatsColumnChart.vue?vue&type=script&lang=js"
export * from "./tensionBeatsColumnChart.vue?vue&type=script&lang=js"
import style0 from "./tensionBeatsColumnChart.vue?vue&type=style&index=0&id=c15cdd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15cdd6a",
  null
  
)

export default component.exports